import { render, staticRenderFns } from "./AssignmentEdit.vue?vue&type=template&id=12b57c16&"
import script from "./AssignmentEdit.vue?vue&type=script&lang=js&"
export * from "./AssignmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports